<form [formGroup]="form()" class="form-group">
    @if (label()) {
        <label for="{{ id() }}Control"
            [ngClass]="{
                'heading-5 fw-bold mb-3': description(),
                'mb-2': !labelIsHidden() && !description(),
                'sr-only': labelIsHidden(),
            }">{{ label() }}</label>
    }
    @if (description()) {
        <div class="heading-6 fw-semi-bold muted mb-3 d-block">{{ description() }}</div>
    }
    <div class="input-group puggles-input-group">
        <textarea id="{{ id() }}Control"
            [formControlName]="id()"
            class="form-control puggles-text-area-field"
            [class.py-7]="description()"
            [placeholder]="placeholder()"
            [rows]="rows()"></textarea>
    </div>
    @if (maxLength()) {
        <div class="d-flex justify-content-end mt-1">
            <span class="fs-7" [class.text-muted]="!isOverLimit" [class.text-validation-error]="isOverLimit">{{ currentLength }} / {{ maxLength() }}</span>
        </div>
    }
    @if (formatPlaceholder()) {
        <div class="mt-1">
            <span class="ps-3 fs-6 text-muted">{{ formatPlaceholder() }}</span>
        </div>
    }
</form>
